import React, { useEffect, useState } from "react";
import logo from "../assets/img/logo-hcp-yeni.png";
import projectsData from "../data/projects.json";

const navLinks = [
    { href: "/projects", label: "Projeler" },
    { href: "/about", label: "Hakkımızda" },
    { href: "/contact", label: "Bize Ulaşın" },
];

const socialLinks = [
    { icon: "fa-facebook-f", url: "https://www.facebook.com/wwwhcpyapicom" },
    { icon: "fa-instagram", url: "https://www.instagram.com/hcp_yapi/" },
    { icon: "fa-youtube", url: "https://www.youtube.com/@hcpyapi939" },
];

const projectLinks = Object.values(projectsData).map(p => ({
    slug: p.slug,
    name: p.name,
    completed: p.completed || false,
}));

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (mobileOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => { document.body.style.overflow = ""; };
    }, [mobileOpen]);

    const handleNavClick = (e, link) => {
        if (link.href === "/iletisim") {
            e.preventDefault();
            window.location.href = "https://wa.me/905053336335";
        }
    };

    return (
        <header className={`glass-header${scrolled ? " glass-header--scrolled" : ""}`}>
            <div className="glass-header__inner container-fluid px-3 px-md-5 d-flex align-items-center justify-content-between">
                <a href="/" className="glass-header__logo d-flex align-items-center">
                    <img src={logo} alt="HCP YAPI" />
                </a>

                <nav className="glass-header__nav d-none d-md-flex align-items-center gap-3">
                    {navLinks.map(link =>
                        link.href === "/projects" ? (
                            <div className="nav-dropdown" key={link.href}>
                                <a
                                    href={link.href}
                                    className="glass-header__nav-link nav-dropdown-toggle"
                                    tabIndex={0}
                                >
                                    {link.label}
                                </a>
                                <div className="nav-dropdown-menu">
                                    {projectLinks.map(proj => (
                                        <a
                                            href={`/projects/${proj.slug}`}
                                            className="nav-dropdown-item"
                                            key={proj.slug}
                                            tabIndex={0}
                                        >
                                            <span className="nav-dropdown-item__name">{proj.name}</span>
                                            <span className={`nav-dropdown-item__status ${proj.completed ? "completed" : "inprogress"}`}>
                                                {proj.completed ? " - Satış Tamamlandı" : " - Satış Devam Ediyor"}
                                            </span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <a
                                key={link.href}
                                href={link.href}
                                className="glass-header__nav-link"
                                onClick={e => handleNavClick(e, link)}
                            >
                                {link.label}
                            </a>
                        )
                    )}
                </nav>

                <div className="glass-header__social d-none d-md-flex align-items-center">
                    {socialLinks.map(s => (
                        <a key={s.icon} href={s.url} className="glass-header__social-btn" target="_blank" rel="noopener noreferrer">
                            <i className={`fab ${s.icon}`}></i>
                        </a>
                    ))}
                </div>

                <button
                    className={`glass-header__hamburger d-md-none${mobileOpen ? " is-active" : ""}`}
                    onClick={() => setMobileOpen(v => !v)}
                    aria-label="Menüyü Aç"
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>

            <div className={`glass-header__mobile-menu${mobileOpen ? " open" : ""}`}>
                <nav className="glass-header__mobile-nav">
                    <button
                        className="glass-header__mobile-close"
                        onClick={() => setMobileOpen(false)}
                        aria-label="Menüyü Kapat"
                    >
                        &times;
                    </button>
                    <div className="glass-header__mobile-links">
                        {navLinks.map(link =>
                            link.href === "/projects" ? (
                                <div className="nav-dropdown-mobile" key={link.href}>
                                    <div className="glass-header__mobile-link" tabIndex={0}>{link.label}</div>
                                    <div className="nav-dropdown-menu-mobile">
                                        {projectLinks.map(proj => (
                                            <a
                                                href={`/projects/${proj.slug}`}
                                                className="nav-dropdown-item"
                                                key={proj.slug}
                                                tabIndex={0}
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                {proj.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <a
                                    key={link.href}
                                    href={link.href}
                                    className="glass-header__mobile-link"
                                    onClick={e => handleNavClick(e, link)}
                                >
                                    {link.label}
                                </a>
                            )
                        )}
                    </div>
                    <div className="glass-header__mobile-social">
                        {socialLinks.map(s => (
                            <a key={s.icon} href={s.url} className="glass-header__social-btn" target="_blank" rel="noopener noreferrer">
                                <i className={`fab ${s.icon}`}></i>
                            </a>
                        ))}
                    </div>
                </nav>
                {mobileOpen && (
                    <div
                        className="glass-header__mobile-backdrop"
                        onClick={() => setMobileOpen(false)}
                    />
                )}
            </div>
        </header>
    );
}
